export const TOGGLE_IS_LOADING = "TOGGLE_IS_LOADING";
export const toggle_is_loading = () => ({ type: TOGGLE_IS_LOADING });
